import { Bot, BadgeCheck, Rocket, ShieldCheck } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { useSection } from "../../lib/content";

const ICONS = [Bot, BadgeCheck, Rocket, ShieldCheck];

export const VideoOS = () => {
  const c = useSection("videoos");

  return (
    <section id="videoos" className="relative bg-slate-50 py-28 lg:py-36 overflow-hidden">
      <span className="pointer-events-none select-none absolute -top-6 right-0 font-display font-extrabold text-[16rem] leading-none text-outline hidden lg:block">
        5.0
      </span>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHead chapter="03" eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {c.cards.map((card, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={card.title} delay={i * 0.1} className="h-full">
                <div className="group relative h-full rounded-2xl border border-[#2a2a2a] bg-[#1a1a1a] p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#024AD8] hover:shadow-[0_24px_48px_-20px_rgba(15,23,42,0.25)]">
                  <span className="font-mono text-xs font-bold text-[#4a4a4a] group-hover:text-[#FF5050] transition-colors duration-300">
                    0{i + 1}
                  </span>
                  <span className="mt-6 w-12 h-12 rounded-2xl bg-[#024AD8] text-white grid place-items-center transition-colors duration-300 group-hover:bg-[#FF5050]">
                    <Icon className="w-5 h-5" />
                  </span>
                  <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-white">{card.title}</h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed">{card.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
